module.exports = __webpack_public_path__ + "static/HorseRace-687c1a6f4f41ddb33ea7a9838c1e9546.jpg";